module.exports = __webpack_public_path__ + "static/media/wcp_pub_tra_poi.897ca153.png";